import React, { Component } from 'react';
import Card from 'antd/es/card/Card';
import Title from 'antd/es/typography/Title';
import { Link } from 'react-router-dom';
import routesConfig from '../../../config/routes';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { ReactComponent as LogoIcon } from '../assets/logo.svg';
import { Flex } from 'antd';

interface Props {
  isAuth?: boolean;
}

class _Logo extends Component<Props> {
  static contextType = AppContext;
  render() {
    const breakPoint = this.context as AppContextValue;
    const home = this.props?.isAuth ? routesConfig.gameKnb : routesConfig.home;

    if (breakPoint?.isMobile) {
      return (
        <Link to={home}>
          <Title style={{ fontSize: 14, fontWeight: 600 }}>{'relax time'}</Title>
        </Link>
      );
    }

    return (
      <Link to={home}>
        <Card bordered={false} style={{ marginBottom: 8, cursor: 'pointer' }}>
          <Flex align={'center'} style={{ paddingLeft: 10 }}>
            <LogoIcon />
            <Title style={{ fontSize: 18, fontWeight: 600, marginLeft: 30 }}>{'relax time'}</Title>
          </Flex>
        </Card>
      </Link>
    );
  }
}

export const Logo = _Logo;
